// import { Button } from "@mui/material";
// import axios from "axios";
// import { useFormik } from "formik";
// import React, { useEffect, useState } from "react";
// import "react-quill/dist/quill.snow.css";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import { baseUrl } from "../../../Config/baseUrl";
// import ReactQuill from "react-quill";

// export default function AddProject() {
//   const { id } = useParams();
//   const { state } = useLocation();
//   const { type } = useParams();
//   const [data, setData] = useState();
//   const navegate = useNavigate();

//   const [category, setCategory] = useState();

//   const getCategory = () => {
//     axios
//       .get(`${baseUrl}/blog/project-category-api/`, {
//         headers: {
//           Authorization: `Token ${localStorage.getItem("token")}`,
//         },
//       })
//       .then((res) => {
//         setCategory(res.data?.data || {});
//       })
//       .catch((err) => {
//         console.error(err);
//         toast.error(err.message);
//       });
//   };
//   const getProject = () => {
//     axios
//       .get(`${baseUrl}/blog/project-api/?project_id=${state}`, {
//         headers: {
//           Authorization: `Token ${localStorage.getItem("token")}`,
//           "Access-Control-Allow-Origin": "*",
//         },
//       })
//       .then((res) => {
//         console.log("RESPONSE ==== : ", res.data);
//         setData(res.data?.data);
//       })
//       .catch((err) => {
//         console.log("ERROR: ====", err);
//         toast.error(err.message);
//       });
//   };

//   useEffect(() => {
//     state && getProject();
//     getCategory();
//   }, [state]);

//   const formik = useFormik({
//     initialValues: {
//       page_id: id,
//       title: data?.title || "",
//       image: "",
//       content: data?.content || "",
//       projectcategory: data?.projectcategory || "",
//       link: data?.link || "",
//     },
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       const reqbody = new FormData();
//       reqbody.append("store", localStorage.getItem("store_id"));
//       reqbody.append("content", values.content);
//       reqbody.append("title", values.title);
//       {
//         values.image && reqbody.append("image", values.image);
//       }
//       reqbody.append("page_id", id);
//       reqbody.append("projectcategory", values?.projectcategory);
//       reqbody.append("link", values?.link);
//       type === "update" && reqbody.append("project_id", state);
//       type === "add"
//         ? axios
//             .post(
//               `${baseUrl}/blog/project-api/`,
//               { ...values, store: localStorage.getItem("store_id") },
//               {
//                 headers: {
//                   Authorization: `Token ${localStorage.getItem("token")}`,
//                   "Content-Type": "multipart/form-data",
//                 },
//               },
//             )
//             .then((response) => {
//               if (response?.data?.response_code === 200) {
//                 toast.success(response.data.message);
//                 navegate(`/project`);
//                 formik.handleReset();
//               } else {
//                 toast.warn(response.data.message);
//               }
//             })
//             .catch((error) => {
//               toast.error("Error adding blog:", error);
//             })
//         : axios
//             .patch(`${baseUrl}/blog/project-api/`, reqbody, {
//               headers: {
//                 "Content-Type": "multipart/form-data",
//                 Authorization: `Token ${localStorage.getItem("token")}`,
//               },
//             })
//             .then((response) => {
//               if (response?.data?.response_code === 200) {
//                 toast.success(response.data.message);
//                 navegate(`/project`);
//                 formik.handleReset();
//               } else {
//                 toast.warn(response.data.message);
//               }
//             })
//             .catch((error) => {
//               console.error("Error adding blog:", error);
//             });
//     },
//   });

//   return (
//     <div className="flex flex-col justify-center gap-5 py-4 lg:flex-row">
//       <div className="flex flex-col justify-center w-full lg:w-3/5">
//         <div className="mt-5 bg-white shadow-lg">
//           <form onSubmit={formik.handleSubmit}>
//             <div className="p-2 border-gray-300 rounded-md ">
//               <div className="flex flex-col gap-5">
//                 <div className="w-full pl-3 ">
//                   <div>
//                     <p className="p-1 text-sm font-semibold">Category</p>
//                     <select
//                       id="projectcategory"
//                       placeholder="Select Category"
//                       value={formik.values.projectcategory}
//                       onChange={formik.handleChange}
//                       className="w-full p-2 px-4 m-1 border border-gray-300 rounded bg-transparent  outline-none"
//                     >
//                       <option value={""} disabled>
//                         Select Category
//                       </option>
//                       {category?.map((i) => (
//                         <option key={i} value={i?.id}>
//                           {i?.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 </div>

//                 <div className="w-full pl-3 ">
//                   <div>
//                     <p className="p-1 text-sm font-semibold">Title</p>
//                     <input
//                       id="title"
//                       placeholder="Enter title"
//                       value={formik.values.title}
//                       className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                       onChange={formik.handleChange}
//                     />
//                   </div>
//                 </div>
//                 <div className="w-full pl-3 ">
//                   <div>
//                     <p className="p-1 text-sm font-semibold">Content</p>
//                     <input
//                       id="content"
//                       placeholder="Enter title"
//                       value={formik.values.content}
//                       className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                       onChange={formik.handleChange}
//                     />
//                   </div>
//                 </div>

//                 <div className="w-full pl-3 ">
//                   <div>
//                     <p className="p-1 text-sm font-semibold">Url</p>
//                     <input
//                       id="link"
//                       type="url"
//                       placeholder="Enter Url"
//                       value={formik.values.link}
//                       className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                       onChange={formik.handleChange}
//                     />
//                   </div>
//                 </div>
//                 <div className="w-full pl-3 ">
//                   <div>
//                     <p className="p-1 text-sm font-semibold">Image</p>
//                     <input
//                       id="images"
//                       type="file"
//                       className="w-full p-2 px-4 m-1 border border-gray-300 rounded"
//                       onChange={(event) =>
//                         formik.setFieldValue("image", event.target.files[0])
//                       }
//                     />
//                   </div>
//                 </div>

//                 <div className="w-full pl-3 ">
//                   <Button type="submit" variant="contained">
//                     {type === "add" ? "Add" : "Update"}
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { baseUrl } from "../../../Config/baseUrl";

const MAX_GALLERY = 10;
const MAX_SIZE_MB = 5;
const ALLOWED_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"];

const formatSize = (bytes) =>
  bytes > 1024 * 1024
    ? `${(bytes / 1024 / 1024).toFixed(1)} MB`
    : `${Math.max(1, Math.round(bytes / 1024))} KB`;

// Existing gallery from the API: `project_images` = [{ id, image, ... }]
const getGallery = (item) =>
  (Array.isArray(item?.project_images)
    ? item.project_images
    : Array.isArray(item?.images)
      ? item.images
      : []
  )
    .map((i) => (typeof i === "string" ? i : i?.image || i?.url))
    .filter(Boolean);

// Returns an error message for the first invalid file, or ""
const checkFiles = (files) => {
  const badType = files.find((f) => !ALLOWED_TYPES.includes(f.type));
  if (badType)
    return `“${badType.name}” isn’t supported. Use JPG, PNG, WEBP or GIF`;
  const tooBig = files.find((f) => f.size > MAX_SIZE_MB * 1024 * 1024);
  if (tooBig) return `“${tooBig.name}” is larger than ${MAX_SIZE_MB} MB`;
  return "";
};

// ─── Validation ───────────────────────────────────────────────────────────────

const makeValidate = (existingGalleryCount) => (values) => {
  const errors = {};
  const title = values.title.trim();

  if (!values.projectcategory) errors.projectcategory = "Select a category";

  if (!title) errors.title = "Title is required";
  else if (title.length < 3)
    errors.title = "Title must be at least 3 characters";
  else if (title.length > 100)
    errors.title = "Title can’t be longer than 100 characters";

  if (!values.content.trim()) errors.content = "Content is required";

  if (values.link.trim()) {
    try {
      const u = new URL(values.link.trim());
      if (!["http:", "https:"].includes(u.protocol)) throw new Error();
    } catch {
      errors.link = "Enter a valid URL, e.g. https://example.com";
    }
  }

  if (values.image) {
    const msg = checkFiles([values.image]);
    if (msg) errors.image = msg;
  }

  if (values.images.length + existingGalleryCount > MAX_GALLERY) {
    errors.images = `You can have up to ${MAX_GALLERY} gallery images`;
  } else {
    const msg = checkFiles(values.images);
    if (msg) errors.images = msg;
  }

  return errors;
};

// ─── UI bits (compact) ────────────────────────────────────────────────────────

const inputCls = (hasError) =>
  `w-full rounded-lg border px-3 py-2 text-sm outline-none transition-all bg-gray-50/70 focus:bg-white ${
    hasError
      ? "border-red-400 focus:ring-2 focus:ring-red-100"
      : "border-gray-200 hover:border-blue-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
  }`;

function Field({ label, error, hint, className = "", children }) {
  return (
    <div className={`${error ? "af-shake" : ""} ${className}`}>
      <div className="flex items-center justify-between mb-1">
        <label className="text-xs font-semibold text-gray-700">{label}</label>
        {hint && <span className="text-[11px] text-gray-400">{hint}</span>}
      </div>
      {children}
      <p className="text-[11px] text-red-500 mt-0.5 min-h-[14px] leading-tight">
        {error || ""}
      </p>
    </div>
  );
}

function ImagePicker({
  label,
  hint,
  multiple,
  files,
  existing = [],
  onAdd,
  onRemove,
  error,
  counter,
  className = "",
}) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const previews = useMemo(
    () => files.map((f) => ({ file: f, url: URL.createObjectURL(f) })),
    [files],
  );
  useEffect(
    () => () => previews.forEach((p) => URL.revokeObjectURL(p.url)),
    [previews],
  );

  return (
    <div className={`${error ? "af-shake" : ""} ${className}`}>
      <div className="flex items-center justify-between mb-1">
        <label className="text-xs font-semibold text-gray-700">{label}</label>
        {counter && (
          <span className="text-[11px] text-gray-400">{counter}</span>
        )}
      </div>

      <div
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragging(false);
          onAdd(Array.from(e.dataTransfer.files));
        }}
        className={`cursor-pointer rounded-xl border-2 border-dashed px-3 py-2.5 flex items-center gap-3 transition-all duration-300 ${
          error
            ? "border-red-400 bg-red-50/50"
            : dragging
              ? "border-blue-500 bg-blue-50 scale-[1.01]"
              : "border-gray-300 bg-gray-50/60 hover:border-blue-400 hover:bg-blue-50/50"
        }`}
      >
        <div
          className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center bg-blue-100 text-blue-600 transition-transform ${
            dragging ? "scale-125" : ""
          }`}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
        </div>
        <div className="min-w-0">
          <p className="text-xs font-semibold text-gray-800 truncate">
            {multiple
              ? "Drop images or click to browse"
              : "Drop image or click"}
          </p>
          <p className="text-[11px] text-gray-500 truncate">{hint}</p>
        </div>
        <input
          ref={inputRef}
          type="file"
          multiple={multiple}
          accept={ALLOWED_TYPES.join(",")}
          className="hidden"
          onChange={(e) => {
            onAdd(Array.from(e.target.files || []));
            e.target.value = ""; // allow picking the same file again
          }}
        />
      </div>
      <p className="text-[11px] text-red-500 mt-0.5 min-h-[14px] leading-tight">
        {error || ""}
      </p>

      {(existing.length > 0 || previews.length > 0) && (
        <div className="flex flex-wrap gap-2 mt-1">
          {existing.map((src, i) => (
            <img
              key={`e-${i}`}
              src={src}
              alt=""
              title="Current"
              className="w-12 h-12 rounded-lg object-cover border border-gray-200"
            />
          ))}
          {previews.map((p, i) => (
            <div
              key={p.url}
              title={`${p.file.name} · ${formatSize(p.file.size)}`}
              className="group relative w-12 h-12 rounded-lg overflow-hidden ring-2 ring-blue-500"
              style={{ animation: "afPop .3s cubic-bezier(.2,.9,.3,1.2)" }}
            >
              <img
                src={p.url}
                alt={p.file.name}
                className="w-full h-full object-cover"
              />
              <button
                type="button"
                onClick={() => onRemove(i)}
                aria-label={`Remove ${p.file.name}`}
                className="absolute inset-0 bg-black/60 text-white text-base leading-none flex items-center justify-center opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Page ─────────────────────────────────────────────────────────────────────

export default function AddProject() {
  const { id, type } = useParams();
  const { state } = useLocation();
  const [data, setData] = useState();
  const navegate = useNavigate();

  const [category, setCategory] = useState();

  const getCategory = () => {
    axios
      .get(`${baseUrl}/blog/project-category-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setCategory(res.data?.data || {});
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.message);
      });
  };
  const getProject = () => {
    axios
      .get(`${baseUrl}/blog/project-api/?project_id=${state}`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        console.log("RESPONSE ==== : ", res.data);
        setData(res.data?.data);
      })
      .catch((err) => {
        console.log("ERROR: ====", err);
        toast.error(err.message);
      });
  };

  useEffect(() => {
    state && getProject();
    getCategory();
  }, [state]);

  const existingCover = typeof data?.image === "string" ? data.image : "";
  const existingGallery = getGallery(data);

  const formik = useFormik({
    initialValues: {
      page_id: id,
      title: data?.title || "",
      image: "",
      images: [], // multiple files, sent as binary under the `images` key
      content: data?.content || "",
      projectcategory: data?.projectcategory || "",
      link: data?.link || "",
    },
    enableReinitialize: true,
    validate: makeValidate(existingGallery.length),
    onSubmit: (values) => {
      const reqbody = new FormData();
      reqbody.append("store", localStorage.getItem("store_id"));
      reqbody.append("content", values.content);
      reqbody.append("title", values.title);
      {
        values.image && reqbody.append("image", values.image);
      }
      // one `images` entry per file → multipart binary
      values.images.forEach((file) => reqbody.append("images", file));
      reqbody.append("page_id", id);
      reqbody.append("projectcategory", values?.projectcategory);
      reqbody.append("link", values?.link);
      type === "update" && reqbody.append("project_id", state);

      // returning the promise keeps formik.isSubmitting true until the request finishes
      return type === "add"
        ? axios
            .post(`${baseUrl}/blog/project-api/`, reqbody, {
              headers: {
                Authorization: `Token ${localStorage.getItem("token")}`,
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response?.data?.response_code === 200) {
                toast.success(response.data.message);
                navegate(`/project`);
                formik.handleReset();
              } else {
                toast.warn(response.data.message);
              }
            })
            .catch((error) => {
              toast.error(
                error?.response?.data?.message || "Error adding project",
              );
            })
        : axios
            .patch(`${baseUrl}/blog/project-api/`, reqbody, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${localStorage.getItem("token")}`,
              },
            })
            .then((response) => {
              if (response?.data?.response_code === 200) {
                toast.success(response.data.message);
                navegate(`/project`);
                formik.handleReset();
              } else {
                toast.warn(response.data.message);
              }
            })
            .catch((error) => {
              console.error("Error adding blog:", error);
              toast.error(
                error?.response?.data?.message || "Error updating project",
              );
            });
    },
  });

  const show = (name) =>
    (formik.touched[name] || formik.submitCount > 0) && formik.errors[name];

  const coverFiles = useMemo(
    () => (formik.values.image ? [formik.values.image] : []),
    [formik.values.image],
  );

  const addGallery = (list) => {
    if (!list.length) return;
    const merged = [...formik.values.images];
    list.forEach((f) => {
      if (!merged.some((m) => m.name === f.name && m.size === f.size))
        merged.push(f);
    });
    formik.setFieldValue("images", merged);
    formik.setFieldTouched("images", true, false);
  };

  const isUpdate = type !== "add";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white px-4 py-4">
      <style>{`
        @keyframes afIn { from { opacity: 0; transform: translateY(16px) } to { opacity: 1; transform: none } }
        @keyframes afPop { from { opacity: 0; transform: scale(.85) } to { opacity: 1; transform: none } }
        @keyframes afShake { 0%,100% { transform: translateX(0) } 20% { transform: translateX(-5px) } 40% { transform: translateX(4px) } 60% { transform: translateX(-3px) } 80% { transform: translateX(2px) } }
        .af-shake { animation: afShake .35s ease-in-out }
        @media (prefers-reduced-motion: reduce) { .af-shake { animation: none } }
      `}</style>

      <div
        className="w-full max-w-4xl rounded-2xl bg-white border border-gray-100 shadow-xl shadow-blue-900/5 p-5"
        style={{ animation: "afIn .5s cubic-bezier(.2,.8,.2,1)" }}
      >
        {/* Header */}
        <div className="flex items-center gap-3 mb-3">
          <button
            type="button"
            onClick={() => navegate(-1)}
            aria-label="Back"
            className="w-8 h-8 rounded-full border border-gray-200 text-gray-500 hover:text-blue-700 hover:border-blue-300 hover:-translate-x-0.5 transition-all"
          >
            ←
          </button>
          <h1 className="text-xl font-extrabold text-blue-900">
            {isUpdate ? "Update Project" : "Add Project"}
          </h1>
        </div>

        <form onSubmit={formik.handleSubmit} noValidate>
          {/* Row 1: category / title / url */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-3">
            <Field label="Category" error={show("projectcategory")}>
              <select
                id="projectcategory"
                name="projectcategory"
                value={formik.values.projectcategory}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`${inputCls(show("projectcategory"))} cursor-pointer`}
              >
                <option value={""} disabled>
                  Select Category
                </option>
                {category?.map((i) => (
                  <option key={i?.id} value={i?.id}>
                    {i?.name}
                  </option>
                ))}
              </select>
            </Field>

            <Field
              label="Title"
              error={show("title")}
              hint={`${formik.values.title.length}/100`}
            >
              <input
                id="title"
                name="title"
                placeholder="Enter title"
                value={formik.values.title}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={inputCls(show("title"))}
              />
            </Field>

            <Field label="Url" error={show("link")}>
              <input
                id="link"
                name="link"
                type="url"
                placeholder="https://example.com"
                value={formik.values.link}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={inputCls(show("link"))}
              />
            </Field>
          </div>

          {/* Row 2: content */}
          <Field label="Content" error={show("content")}>
            <textarea
              id="content"
              name="content"
              rows={2}
              placeholder="Enter content"
              value={formik.values.content}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`${inputCls(show("content"))} resize-none`}
            />
          </Field>

          {/* Row 3: cover + gallery side by side */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-3">
            <ImagePicker
              label="Cover image"
              hint={`Up to ${MAX_SIZE_MB} MB`}
              multiple={false}
              files={coverFiles}
              existing={existingCover ? [existingCover] : []}
              error={show("image")}
              onAdd={(list) => {
                if (!list.length) return;
                formik.setFieldValue("image", list[0]);
                formik.setFieldTouched("image", true, false);
              }}
              onRemove={() => formik.setFieldValue("image", "")}
            />

            <ImagePicker
              className="sm:col-span-2"
              label="Gallery images"
              hint={`Multiple · ${MAX_SIZE_MB} MB each · max ${MAX_GALLERY}`}
              multiple
              files={formik.values.images}
              existing={existingGallery}
              counter={`${existingGallery.length + formik.values.images.length}/${MAX_GALLERY}`}
              error={show("images")}
              onAdd={addGallery}
              onRemove={(i) =>
                formik.setFieldValue(
                  "images",
                  formik.values.images.filter((_, idx) => idx !== i),
                )
              }
            />
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-3 mt-2">
            <button
              type="button"
              onClick={() => navegate(-1)}
              className="rounded-lg border border-gray-300 px-5 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={formik.isSubmitting}
              className={`min-w-[120px] rounded-lg px-6 py-2 text-sm font-semibold text-white flex items-center justify-center gap-2 transition-all ${
                formik.isSubmitting
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-gradient-to-r from-blue-600 to-indigo-600 shadow-md shadow-blue-300/50 hover:-translate-y-0.5 hover:shadow-lg active:scale-95"
              }`}
            >
              {formik.isSubmitting && (
                <span className="w-4 h-4 rounded-full border-2 border-white/60 border-t-transparent animate-spin" />
              )}
              {formik.isSubmitting
                ? "Saving…"
                : type === "add"
                  ? "Add"
                  : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
